import { render, staticRenderFns } from "./RolesAssignedList.vue?vue&type=template&id=90bb863c"
import script from "./RolesAssignedList.vue?vue&type=script&lang=js"
export * from "./RolesAssignedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports